import { switchFolderAndCreateTasks } from '../actions/publicActions';
import { orchestrator } from 'satcheljs';
import { getDefaultFolderId } from '../selectors/getDefaultFolderId';
import getSelectedFolderView from '../selectors/getSelectedFolderView';
import { initializePanelData } from './initializePanelData';
import canCreateTaskInFolder from '../utils/canCreateTaskInFolder';
import { createTasks } from './createTasks';
import { switchFolderAsync } from './switchFolderAsync';

export const switchFolderAndCreateTasksOrchestrator = orchestrator(
    switchFolderAndCreateTasks,
    async actionMessage => {
        // Await on panel initiailialization to ensure panel data is loaded before adding a task.
        await initializePanelData(false);
        let { todos, folderId } = actionMessage;
        const folderToCreateIn = folderId ? folderId : getFolderToCreateIn();
        if (folderToCreateIn !== getSelectedFolderView().folderId) {
            switchFolderAsync(folderToCreateIn);
        }
        createTasks(todos, folderToCreateIn);
    }
);

function getFolderToCreateIn() {
    const selectedFolderView = getSelectedFolderView();
    if (canCreateTaskInFolder(selectedFolderView.folderId)) {
        return selectedFolderView.folderId;
    } else {
        return getDefaultFolderId();
    }
}
